import React from 'react'
import { Outlet } from 'react-router-dom'

import {
  ANALYTICS_LIMITED,
  ANALYTICS_UNLIMITED,
} from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'

import Insights from './Insights'

const InsightsContainer = (): React.ReactNode => {
  const isFeatureEnabled: boolean = useFeatureEnabled(ANALYTICS_UNLIMITED)
  const isFeatureLimited: boolean = useFeatureEnabled(ANALYTICS_LIMITED)
  return <Insights disabled={!isFeatureEnabled && !isFeatureLimited} />
}

export { default as InsightsRecipients } from './recipients/loader'
export { default as InsightsRecipientsPlaylistsDownloads } from './recipients/playlists-downloads'
export { default as InsightsRecipientsPlaylistsViews } from './recipients/playlists-views'
export { default as InsightsRecipientsTracksDownloads } from './recipients/tracks-downloads'
export { default as InsightsRecipientsTracksPlaybacks } from './recipients/tracks-playbacks'
export { default as InsightsRecipientsUsersActivity } from './recipients/users-activity'
export { default as InsightsReports } from './reports'
export { default as InsightsTeam } from './team'
export { default as InsightsTeamTracksPitches } from './team/tracks-pitches'
export { default as InsightsTeamTracksPlaybacks } from './team/tracks-playbacks'
export { default as InsightsTeamUsersPlaylists } from './team/users-playlists'
export default InsightsContainer
